// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4479614d","239":"2f60ddfc","596":"fd942118"}[chunkId] + ".chunk.js";
};